/**
 * Drop keys whose value is undefined, so a partial save cannot blank a field.
 *
 * `''` and `false` are REAL values a creator chose and must survive; only
 * `undefined` means "the caller doesn't know, leave what's there alone".
 *
 * Its own module with NO imports: putting it in mission.ts drags firebase/config
 * into the unit test, which calls getAuth() at module load and fails CI with
 * auth/invalid-api-key.
 */
export function definedOnly<T extends Record<string, unknown>>(obj: T): Partial<T> {
  const out: Partial<T> = {};
  for (const [k, v] of Object.entries(obj)) {
    if (v !== undefined) (out as Record<string, unknown>)[k] = v;
  }
  return out;
}
